import { useEffect, useRef } from 'react';

import { syncMixpanelAuthenticatedUser } from '@/lib/mixpanel/mixpanel';
import { useCurrentUser } from '@/user/use-current-user.query';

export const useMixpanelAuthenticatedUser = (): void => {
  const { data: user } = useCurrentUser();
  const lastSyncedContextKey = useRef<string | null>(null);

  useEffect(() => {
    if (user === undefined || user === null) {
      lastSyncedContextKey.current = null;
      return;
    }

    const contextKey = `${user.id}:${user.account.id}`;

    if (lastSyncedContextKey.current === contextKey) {
      return;
    }

    lastSyncedContextKey.current = contextKey;
    syncMixpanelAuthenticatedUser(user);
  }, [user]);
};
